module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/recommend_3_04-e17de199b1ff079369f5637a55502ed2.jpg";